module.exports = "<div class=\"modal-wrap\">\n  <div class=\"modal-mask\"></div>\n  <div class=\"modal-content\"><ng-content></ng-content></div>\n</div>"